import {Menu} from '@dropbox/dig-components/menu';
import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {CheckmarkLine, ChevronRightLine} from '@dropbox/dig-icons/assets';
import {WorkstreamEdit, WorkstreamPrivacy} from 'client';
import {t} from 'i18next';
import {type ReactNode} from 'react';

import {usePrivacyText} from './hooks';

export const getWorkstreamPrivacyLabel = (privacy?: WorkstreamPrivacy | null) => {
  switch (privacy) {
    case WorkstreamPrivacy.PUBLIC:
      return t('workstream_settings_privacy_public').toString();
    case WorkstreamPrivacy.PRIVATE:
      return t('workstream_settings_privacy_private').toString();
    case WorkstreamPrivacy.CUSTOM:
      return t('workstream_settings_privacy_custom').toString();
    default:
      return '';
  }
};

export const WorkstreamPrivacyActionItem = ({
  workstream,
  value,
  rightAccessory,
  compact = false,
}: {
  workstream: WorkstreamEdit;
  value: WorkstreamPrivacy;
  rightAccessory?: ReactNode;
  compact?: boolean;
}) => {
  const isSelected = workstream.privacy === value;
  const {title, subtitle} = usePrivacyText(workstream, value);

  return (
    <Menu.ActionItem
      key={value}
      value={value}
      withTitle={
        <Text isBold tagName="label">
          {title}
        </Text>
      }
      withSubtitle={compact ? undefined : subtitle}
      withRightAccessory={
        rightAccessory ||
        (isSelected && <UIIcon src={CheckmarkLine} className={atoms({color: 'Border Base'})} />)
      }
      className={atoms({
        paddingX: compact ? '6' : '8',
        paddingY: compact ? '6' : '12',
        borderRadius: compact ? 'Small' : 'Medium',
        borderStyle: compact ? undefined : 'Solid',
        borderColor: compact ? undefined : isSelected ? 'transparent' : 'Border Subtle',
        backgroundColor: isSelected ? 'Opacity Surface' : undefined,
      })}
    />
  );
};

export const WorkstreamPrivacyCustomAccessory = () => (
  <UIIcon src={ChevronRightLine} className={atoms({color: 'Border Base'})} />
);
